import { map } from "rxjs/operators";
import { GET, POST } from "../module/services/fetch";

export const entitlementsByOuIdService = (id: string | number) =>
  GET(`entitlements?ou=${id}`).pipe(map((response: any) => response));

export const techUsersEntitlementsByOuIdService = (id: string | number) =>
  GET(`technical-users/entitlements/find?ou=${id}`).pipe(
    map((response: any) => response)
  );

export const entitlementsService = (obj: {}) =>
  POST("entitlements", obj).pipe(map((response: any) => response));

export const fetchChainEntitlementService = (ids: string[]) => {
  let queryParam: string = ids.join(",");
  return GET(`entitlements/entitlementsbyids?ids=${queryParam}`).pipe(
    map((response: any) => response)
  );
};
